
import { Marker } from "@react-google-maps/api";
import { Department } from "./departmentData";

interface DepartmentMarkerProps {
  department: Department;
  onClick: (department: Department) => void;
}

const DepartmentMarker = ({ department, onClick }: DepartmentMarkerProps) => {
  return (
    <Marker
      key={department.code}
      position={{ lat: department.coordinates[1], lng: department.coordinates[0] }}
      onClick={() => onClick(department)}
      icon={{
        url: `data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="%23F97316" stroke="%23FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg>`,
        scaledSize: new window.google.maps.Size(30, 30)
      }}
    />
  );
};

export default DepartmentMarker;
